import { actionTypes } from '../actions/pixel.action';
const initialState = {
    pixels: {
        data: []
    },
    pixel: {},
    error: {},
    success: false
}

const PixelReducer = (state = initialState, { type, payload, isLoadMore }) => {
    switch (type) {

    case actionTypes.INDEX:
        if(isLoadMore) {
            payload.pixels.data = state.pixels.data.concat(payload.pixels.data)
        }

        return { ...state, ...payload }

    case actionTypes.UPDATE:
        let index = state.pixels.data.findIndex(item => item.id === payload.id)
        state.pixels.data[index] = payload

        return {
            ...state,
            pixels: {
                ...state.pixels,
                data: [
                    ...[(index < 0) && payload],
                    ...state.pixels.data
                ]
            }
        }

    case actionTypes.DESTROY:
        return {
            ...state,
            pixels: {
                ...state.pixels,
                data: state.pixels.data.filter(item => item.id !== payload)
            }

        }

    case actionTypes.CHANGE:
        return {
            ...state,
            pixel: (payload === 'clear') ? {} : {
                ...state.pixel,
                ...payload
            }
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default PixelReducer